import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeAdminOption } from 'src/types/shared/AdminUser';

export const populateCreateChallengeGroupAdminsRequest = createAction(
    'populateCreateChallengeGroupAdminsRequest',
);
export const populateCreateChallengeGroupAdminsSuccess = createAction<ChallengeAdminOption[]>(
    'populateCreateChallengeGroupAdminsSuccess',
);
export const populateCreateChallengeGroupAdminsFailure = createAction(
    'populateCreateChallengeGroupAdminsFailure',
);

export const populateCreateChallengeGroupAdmins = () => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(populateCreateChallengeGroupAdminsRequest());
    try {
        const { data } = await api.get<ChallengeAdminOption[]>(
            `admin/challengegroups/populate-create-admins`,
        );
        dispatch(populateCreateChallengeGroupAdminsSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, populateCreateChallengeGroupAdminsFailure, e);
    }
};
